import logo from "../../images/everlaunch.png";
import { SDK_APP_URL } from "../../js/variables";

const Home = () => {
  let sdkSrc = `${SDK_APP_URL}/?appKey=kfWIcvhS6qAdS4p`;

  return (
    <div className="home">
      <div className="section1">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-dark">
            <div className="container-fluid">
              <img class="d-block mx-auto" src={logo} height="25" />
            </div>
          </nav>
        </div>
      </div>
      <div className="section2">
        <div className="row mt-5 mb-5">
          <div className="col mx-auto text-center">
            <div className="sdk-wrapper mx-auto text-center">
              <iframe
                className="sdk"
                allow="clipboard-read; clipboard-write; camera;"
                src={sdkSrc}
                frameborder="0"
                style={{borderRadius: "20px", marginBottom: "20px"}}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
